module.exports = __webpack_public_path__ + "static/media/earth-cropped.857d9837.avif";